/** Human-readable label for feed f_type shown in the notification bell. */
export const getNotificationTypeLabel = (feedType?: string): string => {
  const normalized = String(feedType || '').trim();
  const labels: Record<string, string> = {
    Added: 'Listing requested',
    List: 'Listed',
    Sold: 'Sold',
    Delist: 'Delisted',
    DelistInProgress: 'Delist requested',
    ListingRequestCancelled: 'Listing cancelled',
    DeleteUser: 'User deleted',
    AppVersionRelease: 'App update',
  };
  return labels[normalized] || normalized || 'Update';
};
